import React from "react";
import { Alert, Button } from "antd";
import { useNavigate } from "react-router-dom";
import CustomButton from "./CustomButton";

type AlertType = "success" | "info" | "warning" | "error";

interface CustomAlertProps {
    type?: AlertType;
    message: string;
    description?: string | React.ReactNode;
    showIcon?: boolean;

    // CTA
    buttonLabel?: string;
    asLink?: boolean;
    to?: string;
    onButtonClick?: () => void;


    ButtonComponent?: React.ComponentType<
        { onClick?: () => void; children?: React.ReactNode } & Record<string, any>
    >;
    buttonProps?: Record<string, any>;
    canShowButton?: boolean;

    style?: React.CSSProperties;
    className?: string;
}

const CTA_COLORS: Record<
    AlertType,
    string
> = {
    success: "success",
    info: "info",
    warning: "warning",
    error: "error",
};

const CustomAlert: React.FC<CustomAlertProps> = ({
    type = "info",
    message,
    description,
    showIcon = true,

    buttonLabel,
    asLink = false,
    to,
    onButtonClick,

    ButtonComponent,
    buttonProps,

    style,
    className,
    canShowButton = true,
}) => {
    const navigate = useNavigate();
    const palette = CTA_COLORS[type];

    const handleClick = () => {
        if (asLink && to) {
            navigate(to);
        } else if (onButtonClick) {
            onButtonClick();
        }
    };

    const FallbackButton = (
        <CustomButton
            onClick={handleClick}
            variant={palette as any}
        >
            {buttonLabel}
        </CustomButton>
    );

    return (
        <Alert
            type={type}
            showIcon={showIcon}
            message={message}
            description={
                <div>
                    <div>{description}</div>
                    {buttonLabel && canShowButton &&  (
                        <div style={{ marginTop: 8 }}>
                            {ButtonComponent ? (
                                <ButtonComponent
                                    onClick={handleClick}
                                    {...({ variant: palette, alertType: type } as any)}
                                    {...buttonProps}
                                >
                                    {buttonLabel}
                                </ButtonComponent>
                            ) : (
                                FallbackButton
                            )}
                        </div>
                    )}
                </div>
            }
            style={{ borderRadius: 8, ...style }}
            className={className}
        />
    );
};

export default CustomAlert;
